// 官方内容模块枚举与展示映射
// 列表数据已走真实接口（GET /official，OfficialContentService），此处只留纯枚举与展示函数
// category 走字典 content_category（业务表存字典数字 _id）

// 内容形式：1 图文 / 2 视频
export const OFFICIAL_TYPE = [
  { value: 1, label: '图文' },
  { value: 2, label: '视频' }
]

// 状态：0 草稿 / 1 已发布 / 2 已下架
export const OFFICIAL_STATUS = [
  { value: 0, label: '草稿', tagType: 'info' },
  { value: 1, label: '已发布', tagType: 'success' },
  { value: 2, label: '已下架', tagType: 'warning' }
]

// ===== 辅助函数 =====

// 内容形式 → 中文标签
export function officialTypeLabel(value) {
  const item = OFFICIAL_TYPE.find(t => t.value === value)
  return item ? item.label : '未知'
}

// 状态 → 中文
export function officialStatusText(value) {
  const item = OFFICIAL_STATUS.find(s => s.value === value)
  return item ? item.label : '未知'
}

// 状态 → 表格 tagType
export function officialStatusTagType(value) {
  const item = OFFICIAL_STATUS.find(s => s.value === value)
  return item ? item.tagType : 'info'
}

// 发布时间展示：publish_time 优先，空则取 created_at（与 doc 一致）
export function officialPublishText(row) {
  if (row.publish_time) return row.publish_time
  if (row.created_at) return `${row.created_at}（创建）`
  return '—'
}
